import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Landing } from "@modules/landings/types";
import { LandingFormValues } from "@modules/landings/validations";

import { createLandingService } from "./service";
import { UseCreateLandingMutationOptions } from "./types";
import { useNavigate } from "react-router";

export function useCreateLandingMutation(
  options?: UseCreateLandingMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<Landing, ApiError, LandingFormValues>({
    mutationFn: createLandingService,
    onSuccess: (landing: Landing) => {
      open?.({
        type: "success",
        message: translate("v1/landing_admin.success.create"),
      });

      navigate(`/landings/edit/${landing.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
